import React from 'react';
import { connect } from 'react-redux';
import { List, ListItem, ListSubHeader, ListDivider, ListItemContent, ListCheckbox } from 'react-toolbox/lib/list';
import Portions from './Portions';
import OrderTags from './OrderTags';
import SelectedOrderTags from './SelectedOrderTags';
import { SelectedOrderStates } from './SelectedOrderStates';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { getProductPortions, getOrderTagsForTerminal } from '../queries';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import * as Queries from '../queries';
import * as Actions from '../actions';

const customContentStyle = {
    'width': '95%'
};

class Order extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDetailsOpen: false,
            selectedPortion: '',
            editQuantity: Number(props.quantity) || 1,
            isUpdatingQuantity: false,
            portions: [{ name: 'loading...' }],
            orderTags: [{ name: 'loading...', price: 1 }]
        };
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }
    render() {
        const { id, name, quantity, price, priceTag, portion, productId, orderUid, orderTags, orderStates,
            onClick = () => { } } = this.props;

        //const isAdmin = this.props.isAdmin === true;
        const isSent = this.props.locked === true;

        const orderActions = this.loadOrderActions();

        const canEditDetails = !isSent;

        const detailActions = [];

        const visiblePortions =
            (this.state.portions || []).filter(x => x && x.name && x.name !== 'loading...');

        const shouldShowPortions =
            visiblePortions.length > 1;

        const visibleOrderTags =
            (this.state.orderTags || []).filter(group =>
                group &&
                group.name &&
                (
                    group.name === 'Ekstra Seçenekler' ||
                    (group.tags && group.tags.length > 0)
                )
            );

        const getOrderTagTotal = () => {
            if (!orderTags || orderTags.length === 0) return 0;
             return orderTags.reduce((total, tag) => {
                const tagPrice = Number(tag.price) || 0;
                const tagQuantity = Number(tag.quantity) || 1;
                return total + (tagPrice * tagQuantity);
            }, 0);
        };
        const getOrderDisplayPrice = () => {
            const basePrice = Number(price) || 0;
            const tagTotal = getOrderTagTotal();
            const orderQuantity = Number(quantity) || 0;
            return (basePrice + (tagTotal * orderQuantity)).toFixed(2);
        };

        orderActions
            .filter(x => this.isOrderActionVisible(x, isSent))
            .forEach(action => {
                detailActions.push(
                    <FlatButton
                        label={action.caption}
                        primary={true}
                        onClick={() => this.executeOrderAction(action)}
                        style={{
                            color: action.foreground || undefined
                        }}
                    />
                );
            });

        detailActions.push(
            <FlatButton
                label="Kaldır"
                primary={true}
                onClick={this.onOrderCancelled}
                disabled={isSent}
            />
        );

        detailActions.push(
            <FlatButton
                label="Kapat"
                primary={true}
                onClick={this.handleDetailsClose}
            />
        );

        const getOrderStateText = () => {
            if (!orderStates || orderStates.length === 0) return '';

            return orderStates
                .map(x =>
                ((x.stateName || '') + ' ' +
                    (x.state || '') + ' ' +
                    (x.stateValue || ''))
                )
                .join(' ');
        };

        const normalizeText = (text) => {
            return (text || '')
                .toLocaleLowerCase('tr-TR')
                .replace(/ı/g, 'i')
                .replace(/İ/g, 'i')
                .replace(/i̇/g, 'i');
        };

        const getOrderLineClassName = () => {
            const text = normalizeText(getOrderStateText());

            if (text.indexOf('ikram') > -1) return 'orderLineGift';
            if (text.indexOf('iade') > -1) return 'orderLineReturn';

            return '';
        };

        const orderLineClassName = getOrderLineClassName();

        var orderName = portion != 'Normal' ? name + '.' + portion : name;
        const orderLine =
            <div className={'orderContent ' + orderLineClassName}>
                <div className="order">
                    <span className="orderQuantity">{quantity}</span>
                    <span className="orderName orderDialogName">{orderName}</span>
                    <span className="orderPrice">
                        <span className="orderPriceTag">{priceTag}</span>
                        <span >{getOrderDisplayPrice()}</span>
                    </span>
                </div>
                <SelectedOrderStates orderStates={orderStates} />
                <SelectedOrderTags orderTags={orderTags} orderQuantity={quantity} />
            </div>;

        return (
            <div key={id}>
                <ListItem selectable ripple={false} onClick={this.handleDetailsOpen.bind(null, productId, portion)}>
                    <ListItemContent>
                        {orderLine}
                    </ListItemContent>
                </ListItem>
                <Dialog
                    title={orderLine}
                    actions={detailActions}
                    modal={true}
                    contentStyle={customContentStyle}
                    autoScrollBodyContent={true}
                    open={this.state.isDetailsOpen}>
                    <div className='dialogContent'>
                        {canEditDetails &&
                            <div>
                                <div className="orderQuantityEditor">
                                    <span className="orderQuantityEditorLabel">Adet</span>
                                    <FlatButton
                                        label="-"
                                        className="orderQuantityEditorButton"
                                        disabled={this.state.isUpdatingQuantity || Number(this.state.editQuantity) <= 1}
                                        onClick={() => this.changeEditQuantity(-1)}
                                    />
                                    <span className="orderQuantityEditorValue">
                                        {this.state.editQuantity}
                                    </span>
                                    <FlatButton
                                        label="+"
                                        className="orderQuantityEditorButton"
                                        disabled={this.state.isUpdatingQuantity}
                                        onClick={() => this.changeEditQuantity(1)}
                                    />
                                    <FlatButton
                                        label="Güncelle"
                                        primary={true}
                                        className="orderQuantityUpdateButton"
                                        disabled={
                                            this.state.isUpdatingQuantity ||
                                            Number(this.state.editQuantity) === Number(quantity)
                                        }
                                        onClick={this.onOrderQuantityUpdate}
                                    />
                                </div>
                                {shouldShowPortions &&
                                    <Portions
                                        portions={visiblePortions}
                                        selectedPortion={this.state.selectedPortion}
                                        onClick={this.onPortionSelected}
                                    />
                                }
                                {visibleOrderTags.length > 0 &&
                                    <OrderTags
                                        orderTags={visibleOrderTags}
                                        onClick={this.onOrderTagSelected}
                                    />
                                }
                            </div>
                        }

                        {!canEditDetails &&
                            <div style={{ padding: '12px', color: '#777' }}>
                                Gönderilmiş siparişlerde porsiyon ve tag değiştirilemez.
                            </div>
                        }
                    </div>
                </Dialog>
            </div>
        );
    }

    onPortionSelected = (name) => {
        this.props.startBusy && this.props.startBusy('Porsiyon güncelleniyor...');

        Queries.updateOrderPortionOfTerminalTicket(this.props.terminalId, this.props.orderUid, name, (ticket) => {
            this.props.setTicket(ticket);

            if (this.state.orderTags && this.state.orderTags.length > 0) {
                this.getOrderTags(this.props.orderUid, (orderTags) => {
                    this.setState({ orderTags: orderTags, selectedPortion: name });
                    this.props.stopBusy && this.props.stopBusy();
                });
            }
            else {
                this.handleDetailsClose();
                this.props.stopBusy && this.props.stopBusy();
            }
        });
    }

    changeEditQuantity = (change) => {
        const currentQuantity = Number(this.state.editQuantity) || 1;
        const nextQuantity = Math.max(1, currentQuantity + change);
        this.setState({ editQuantity: nextQuantity });
    }

    onOrderQuantityUpdate = () => {
        const quantity = Number(this.state.editQuantity);

        if (isNaN(quantity) || quantity <= 0 || this.state.isUpdatingQuantity) {
            return;
        }

        this.setState({ isUpdatingQuantity: true });
        this.props.startBusy && this.props.startBusy('Ürün adedi güncelleniyor...');

        Queries.updateOrderQuantityOfTerminalTicket(
            this.props.terminalId,
            this.props.orderUid,
            quantity,
            (ticket) => {
                try {
                    if (!ticket) {
                        this.props.updateMessage('Ürün adedi güncellenemedi. Lütfen tekrar deneyin.');
                        return;
                    }

                    const currentTicketUid = this.props.ticket && this.props.ticket.uid;
                    if (currentTicketUid && ticket.uid && String(currentTicketUid) !== String(ticket.uid)) {
                        this.props.updateMessage('Adisyon değişmiş görünüyor. Lütfen masayı kontrol edin.');
                        return;
                    }

                    const updatedOrder = (ticket.orders || []).find(x => x.uid === this.props.orderUid);
                    const updatedQuantity = updatedOrder ? updatedOrder.quantity : quantity;

                    this.props.setTicket(ticket);
                    this.setState({ editQuantity: updatedQuantity });
                } finally {
                    this.setState({ isUpdatingQuantity: false });
                    this.props.stopBusy && this.props.stopBusy();
                }
            }
        );
    }

    onOrderTagSelected = (name, tag) => {
        this.props.startBusy && this.props.startBusy('Ürün özelliği güncelleniyor...');

        Queries.updateOrderTagOfTerminalTicket(this.props.terminalId, this.props.orderUid, name, tag, (ticket) => {
            this.props.setTicket(ticket);

            this.getOrderTags(this.props.orderUid, (orderTags) => {
                this.setState({ orderTags: orderTags, isDetailsOpen: true });
                this.props.stopBusy && this.props.stopBusy();
            });
        });
    }

    onOrderCancelled = () => {
        this.props.startBusy && this.props.startBusy('Ürün kaldırılıyor...');
        Queries.cancelOrderOnTerminalTicket(this.props.terminalId, this.props.orderUid, (ticket) => {
            this.props.setTicket(ticket);
            this.props.stopBusy && this.props.stopBusy();
        });
        this.handleDetailsClose();
    }

    onOrderGift = () => {
        this.props.startBusy && this.props.startBusy('İkram işlemi yapılıyor...');

        Queries.executeAutomationCommandForTerminalTicket(
            this.props.terminalId,
            this.props.orderUid,
            'İkram',
            'Müşteri',
            (ticket) => {
                this.props.setTicket(ticket);
                this.props.stopBusy && this.props.stopBusy();
            }
        );

        this.handleDetailsClose();
    }

    onOrderReturn = () => {
        this.props.startBusy && this.props.startBusy('İade işlemi yapılıyor...');

        Queries.executeAutomationCommandForTerminalTicket(
            this.props.terminalId,
            this.props.orderUid,
            'İade',
            'Yanlış Sipariş',
            (ticket) => {
                this.props.setTicket(ticket);
                this.props.stopBusy && this.props.stopBusy();
            }
        );

        this.handleDetailsClose();
    }

    handleDetailsOpen = (productId, portion) => {
        //if (this.props.locked) return;
        getProductPortions(productId, (portions) => {
            this.setState({
                isDetailsOpen: true,
                portions: portions,
                selectedPortion: portion,
                editQuantity: Number(this.props.quantity) || 1
            });
        });
        this.getOrderTags(this.props.orderUid, (orderTags) => {
            this.setState({ orderTags: orderTags });
        });
    };

    getOrderTags = (orderUid, callback) => {
        Queries.getOrderTagsForTerminal(this.props.terminalId, orderUid, (orderTags) => {
            //console.log('ORDER TAG GROUPS:', orderTags);
            //console.log('ORDER TAG GROUPS JSON:', JSON.stringify(orderTags, null, 2));
            callback(orderTags);
        })
    }

    handleDetailsClose = () => {
        this.setState({ isDetailsOpen: false });
    };

    loadOrderActions = () => {
        try {
            const raw = localStorage['pos24_order_actions'];
            return raw ? JSON.parse(raw) : [];
        } catch (e) {
            return [];
        }
    }

    isOrderActionVisible = (action, isSent) => {
        if (!action) return false;

        if (action.adminOnly === true && this.props.isAdmin !== true) {
            return false;
        }

        if (action.lockedOnly === true && !isSent) {
            return false;
        }

        if (action.newOrderOnly === true && isSent) {
            return false;
        }

        return true;
    }

    executeOrderAction = (action) => {
        const commandName = (action.commandName || '').trim();
        const commandValue = (action.commandValue || '').trim();

        if (!commandName) {
            return;
        }

        this.props.startBusy && this.props.startBusy(commandName + ' işlemi yapılıyor...');

        Queries.executeAutomationCommandForTerminalTicket(
            this.props.terminalId,
            this.props.orderUid,
            commandName,
            commandValue,
            (ticket) => {
                try {
                    this.props.setTicket(ticket);
                } finally {
                    this.props.stopBusy && this.props.stopBusy();
                }
            }
        );

        this.handleDetailsClose();
    }
}

const mapStateToProps = state => ({
    terminalId: state.app.get('terminalId'),
    ticket: state.app.get('ticket')
})

const mapDispatchToProps = ({
    setTicket: Actions.setTicket,
    updateMessage: Actions.updateMessage
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Order)



// WEBPACK FOOTER //
// ./app/components/Order.jsx